import React from "react";
import {
	toDataSourceRequestString,
	translateDataSourceResultGroups,
	groupBy
} from "@progress/kendo-data-query";
import store from "../../store";
import CryptoJS from "crypto-js";
import { Alert } from "antd";
import moment from "moment";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
	setExpandedState,
	setGroupIds,
} from "@progress/kendo-react-data-tools";
import apiCalls from '../../api/apiCalls';
const filterOperators = {
	text: [
		{ text: "grid.filterContainsOperator", operator: "contains" },
		{ text: "grid.filterNotContainsOperator", operator: "doesnotcontain" },
		{ text: "grid.filterEqOperator", operator: "eq" },
		{ text: "grid.filterNotEqOperator", operator: "neq" },
		{ text: "grid.filterStartsWithOperator", operator: "startswith" },
		{ text: "grid.filterEndsWithOperator", operator: "endswith" },
		{ text: "grid.filterIsEmptyOperator", operator: "isempty" },
		{ text: "grid.filterIsNotEmptyOperator", operator: "isnotempty" },
	],
	numeric: [
		{ text: "grid.filterEqOperator", operator: "eq" },
		{ text: "grid.filterNotEqOperator", operator: "neq" },
	],
	date: [
		{ text: "grid.filterAfterOrEqualOperator", operator: "gte" },
		{ text: "grid.filterAfterOperator", operator: "gt" },
		{ text: "grid.filterBeforeOperator", operator: "lt" },
		{ text: "grid.filterBeforeOrEqualOperator", operator: "lte" },
	],
	datetime: [
		{ text: "grid.filterEqOperator", operator: "eq" },
		{ text: "grid.filterNotEqOperator", operator: "neq" },
		{ text: "grid.filterAfterOrEqualOperator", operator: "gte" },
		{ text: "grid.filterAfterOperator", operator: "gt" },
		{ text: "grid.filterBeforeOperator", operator: "lt" },
		{ text: "grid.filterBeforeOrEqualOperator", operator: "lte" },
	],
	boolean: [{ text: "grid.filterEqOperator", operator: "eq" }],
};
const processWithGroups = (data, group) => {
	const newDataState = groupBy(data, group);
	setGroupIds({
		data: newDataState,
		group: group,
	});
	return newDataState;
};
export function withState(WrappedGrid) {
	return class StatefullGrid extends React.Component {
		initialState = {
			skip: 0, take: this.props?.pSize || 10, filter: undefined,
			sort: undefined,
			group: []
		}
		constructor(props) {
			super(props);
			this.state = {
				dataState: { ...this.initialState, ...this?.props.dataState },
				additionalParams: null,
				data: [],
				group: [],
				isLoading: false,
				collapsedState: [],
				gridStatus: null,
			};
			this.excelRef = React.createRef();
			this.gridRef = React.createRef();
			this.tempRef = React.createRef();
		}
		numberWithCommas(x) {
			if (!x) {
				return ''
			} else if ((typeof x) === 'string') {
				return x
			}
			x = (typeof x) == 'string' ? x : x?.toString();
			let arParts = x?.split('.');
			let intPart = parseInt(arParts[0])?.toLocaleString();
			let decPart = (arParts.length > 1 ? arParts[1] : '');

			return '' + intPart + (decPart ? ('.' + decPart) : '');
		}

		expandChange = (event) => {
			const item = event.dataItem;
			if (item.groupId) {
				const newCollapsedIds = !event.value
					? [...this.state.collapsedState, item.groupId]
					: this.state.collapsedState.filter(
						(groupId) => groupId !== item.groupId
					);
				this.setState(prevState => ({
					...prevState,
					collapsedState: newCollapsedIds,
				}));
			}
		};

		onGroupsToggle = () => {
			let collapseAllState = []
			if (this.state.result) {
				for (let i in this.state.result) {
					collapseAllState.push(this.state.result[i].groupId)
				}
			}
			const newCollapsedState = this.state.collapsedState.length
				? []
				:
				collapseAllState
			this.setState(prevState => ({
				...prevState,
				collapsedState: newCollapsedState,
			}));
		};
		refreshGrid() {
			this.fetchData(this.props.dataState);
		}
		resetToDefault(initialDataState) {
			this.setState(prevState => ({ ...prevState, dataState: initialDataState, group: initialDataState.group }))
			this.fetchData(initialDataState)
		}
		handleExcelExport = () => {
			if (this.excelRef && this.excelRef.save) {
				const visibleColumns = this.props.columns.filter(col => col.show !== false);
				let workbook = this.excelRef.workbookOptions();
				workbook.sheets[0].rows.forEach((item, index) => {
					if (item.type === "header") {
						for (const i in item.cells) {
							item.cells[i].value = visibleColumns[i].title;
						}
					} else if (item.type === "data") {
						for (const i in visibleColumns) {
							const idx = visibleColumns.length === item.cells.length ? i : i - 1;
							if (visibleColumns[i].filterType === "date") {
								if (item.cells[idx].value) {
									item.cells[idx].value =
										moment(apiCalls.convertUTCToLocalTime(item.cells[idx].value)).format("DD/MM/YYYY hh:mm:ss A");

								}
							}
							if (visibleColumns[i].filterType === "numeric") {
								if (item.cells[idx].value) {
									item.cells[idx].value = this.numberWithCommas(item.cells[idx].value);
								}
								item.cells[idx].textAlign = "right";
							}
							if (visibleColumns[i]?.combine) {
								item.cells[idx].value = this.getCombineFieldValue(this.excelRef.props.data[index - 1], this.props.columns[i].combineFields);
							}
						}
					}
				});
				this.excelRef.save(workbook);
			}
		};

		getCombineFieldValue = (dataItem, fields) => {
			const visibleColumns = this.props.columns.filter(col => col.show !== false);
			for (const i in visibleColumns) {
				if (visibleColumns[i].filterType === "numeric") {
					dataItem[fields[0]] = this.numberWithCommas(dataItem[fields[0]])
					dataItem[fields[1]] = this.numberWithCommas(dataItem[fields[1]])
				}
			}
			return dataItem[fields[0]] && dataItem[fields[1]] ? `${dataItem[fields[0]]} / ${dataItem[fields[1]]}` : (dataItem[fields[0]] || dataItem[fields[1]]);
		}
		exportToPDF = () => {
			if (this.tempRef?.current)
				this.tempRef?.current.save();
		}
		loadingPanel = (
			<div className="k-loading-mask">
				<span className="k-loading-text">Loading</span>
				<div className="k-loading-image"></div>
				<div className="k-loading-color"></div>
			</div>
		);
		render() {
			const dataToShow = (this.state.result)
				? this.state.result
				: this.state.data;
			const newData = setExpandedState({
				data: dataToShow,
				collapsedIds: this.state.collapsedState,
			});
			return (
				<div style={{ position: "relative" }}>
					{this.state.isLoading && this.loadingPanel}
					{this.state.error && (
						<Alert
							style={{ marginBottom: 10, marginTop: 10 }}
							type="error"
							description={this.state?.error}
							showIcon
							closable
						// onClose={""}
						/>
					)}
					{this.props.showExcelExport ? (
						<ExcelExport
							data={newData}
							fileName={this.props?.pKey + ".xlsx"}
							ref={(exporter) => {
								this.excelRef = exporter;
							}}>
							<WrappedGrid
								ref={this.gridRef}
								filterOperators={filterOperators}
								pageable={{ pageSizes: [5, 10, 20, 30, 40, 50, "All"] }}
								{...this.props}
								total={this.state.total}
								data={newData}
								skip={this.state.dataState.skip}
								pageSize={this.state.dataState.take || 10}
								filter={this.state.dataState.filter}
								sort={this.state.dataState.sort}
								onDataStateChange={this.handleDataStateChange}>
								{this.props.children}
							</WrappedGrid>
						</ExcelExport>
					) : (
						<WrappedGrid ref={this.gridRef}
							resizable={true}
							filterOperators={filterOperators}
							pageable={{ pageSizes: [5, 10, 20, 30, 40, 50, "All"] }}
							{...this.props}
							total={this.state.total}
							data={newData}
							skip={this.state.dataState.skip}
							pageSize={this.state.dataState.take}
							filter={this.state.dataState.filter}
							sort={this.state.dataState.sort}
							onDataStateChange={this.handleDataStateChange}
						>
						</WrappedGrid>
					)}
				</div>
			);
		}
		fetchGridCall(dataState) {
			this.fetchData(dataState);
		}
		componentDidUpdate(prevProps) {
			if (this.props.showExcelExport !== prevProps.showExcelExport) {
				if (this.props.showExcelExport) {
					this.handleExcelExport();
				}
			}
			else if ((JSON.stringify(this.props.additionalParams) !== JSON.stringify(prevProps.additionalParams)) || this.props.refresh) {
				const updatedDataState = { ...this.state.dataState };
				updatedDataState.skip = 0;
				this.fetchData(updatedDataState);
			}
			else if ((this.props.url !== prevProps.url)) {
				this.fetchData(this.state?.dataState);
			}
		}
		handleDataStateChange = (changeEvent) => {
			const isObjectEqual = (obj1, obj2) => {
				const obj1Keys = Object.keys(obj1);
				const obj2Keys = Object.keys(obj2);
				if (obj1Keys.length !== obj2Keys.length) return false;
				for (const key of obj1Keys) {
					if (obj1[key] !== obj2[key]) return false;
				}
				return true;
			}
			const didArrayChange = (arr1, arr2) => {
				if ((arr1 === undefined && arr2 === undefined) || (arr1 && !arr1.length && !arr2) || (arr2 && !arr2.length && !arr1)) {
					return false;
				}
				if (!arr1 || !arr2) return true;
				if (arr1.length !== arr2.length) return true;
				for (let i = 0; i < arr1.length; i++) {
					if (!isObjectEqual(arr1[i], arr2[i])) return true;
				}
				return false;
			};
			const applyDataToGrid = (changeEvents) => {
				let _dataState = {
					...this?.props.dataState,
					...changeEvents.dataState
				};
				if (this?.props.dataState?.filter || changeEvents.dataState?.filter) {
					_dataState.filter = {
						...this?.props.dataState?.filter,
						...changeEvents.dataState?.filter,
						filters: [
							...(this?.props.dataState?.filter?.filters || []),
							...(changeEvents.dataState?.filter?.filters || [])
						]
					};
				}
				if (isNaN(_dataState.take)) {
					_dataState.take = this.state.total;
				}

				this.setState(prevState => ({
					...prevState,
					dataState: _dataState
				}));
				this.fetchData(_dataState);
			}
			const { group: prevGroup } = this.state.dataState
			const { group: eventGroup } = changeEvent.dataState
			applyDataToGrid(changeEvent)
			if (didArrayChange(prevGroup, eventGroup)) {
				const newDataState = processWithGroups(this.state.ungroupedData.length > 0 ? this.state.ungroupedData : this.state.data, changeEvent.dataState.group);
				this.setState(prevState => ({
					...prevState,
					collapsedState: [],
					result: changeEvent.dataState.group.length > 0 ? newDataState : undefined,
					group: changeEvent.dataState.group,
				}));
			}
			this.props.getDataStateFromChild(changeEvent.dataState)
		};
		_encrypt(msg, key) {
			msg = typeof msg == "object" ? JSON.stringify(msg) : msg;
			let salt = CryptoJS.lib.WordArray.random(128 / 8);
			key = CryptoJS.PBKDF2(key, salt, {
				keySize: 256 / 32,
				iterations: 10,
			});
			let iv = CryptoJS.lib.WordArray.random(128 / 8);
			let encrypted = CryptoJS.AES.encrypt(msg, key, {
				iv: iv,
				padding: CryptoJS.pad.Pkcs7,
				mode: CryptoJS.mode.CBC,
			});
			return salt.toString() + iv.toString() + encrypted.toString();
		}
		trimFilterValues = (filters) => {
			if (!filters || !Array.isArray(filters)) {
				return undefined;
			}
			const seenFilters = new Set();

			return filters.map(filter => {
				const filterKey = JSON.stringify({
					field: filter.field,
					operator: filter.operator,
					value: typeof filter.value === 'string' ? filter.value.trim() : filter.value
				});
				if (seenFilters.has(filterKey)) {
					return null;
				}
				seenFilters.add(filterKey);
				if (filter.filters) {
					const processedFilters = this.trimFilterValues(filter.filters);
					return {
						...filter,
						filters: processedFilters ? processedFilters.filter(Boolean) : undefined
					};
				}
				return {
					...filter,
					value: typeof filter.value === 'string' ? filter.value.trim() : filter.value
				};
			}).filter(Boolean);
		};
		fetchData(dataState) {
			this.props.refreshCallBack?.(false)
			const updatedDataState = {
				...dataState,
				filter: dataState?.filter?.filters
					? {
						...dataState.filter,
						filters: this.trimFilterValues(dataState.filter.filters) // Assign trimmed filters
					}
					: undefined
			};
			if (updatedDataState.filter) {
				updatedDataState.filter.filters?.map((item) => {
					item.filters?.map((value) => {
						if (
							value.operator === "gte" ||
							value.operator === "gt" ||
							value.operator === "lte" ||
							value.operator === "lt"
						) {
							value.value = value.value && (
								value.operator === "lte" || value.operator === "gt"
									? new Date(moment(value.value).format("YYYY-MM-DDT23:59:59"))
									: new Date(moment(value.value).format("YYYY-MM-DDT00:00:00"))
							);
						}
					});
				});
			}
			this.setState(prevState => ({ ...prevState, isLoading: true }));
			const {
				oidc: { deviceToken },
			} = store.getState();
			let queryStr = `${toDataSourceRequestString(updatedDataState)}`;
			const hasGroups = updatedDataState.group && updatedDataState.group.length;
			if (this.props.additionalParams) {
				let _additionalParams = "";
				for (let key in this.props.additionalParams) {
					_additionalParams =
						_additionalParams + `/${this.props.additionalParams[key]}`;
				}
				queryStr = _additionalParams + "?" + queryStr;
			} else {
				queryStr = "?" + queryStr;
			}
			let base_url = this.props.url;
			const Authorization = `Bearer ${deviceToken}`;
			const init = {
				method: "GET",
				accept: "application/json",
				headers: {
					Authorization: Authorization,
				},
			};
			fetch(`${base_url}${queryStr}`, init)
				.then(response => {
					if (response.ok) {
						this.setState(prevState => ({ ...prevState, gridStatus: response?.status, error: null }))
						return response.json()
					} else {
						this.setState(prevState => ({ ...prevState, error: apiCalls.isErrorDispaly(response), isLoading: false, data: [] }))
					}
				})
				.then(({ data, total, items, totalCount }) => {
					function extractObjectsWithId(items) {
						let results = [];
						items.forEach(item => {
							if (item.items) {
								results = results.concat(extractObjectsWithId(item.items));
							} else if (item.id) {
								results.push(item);
							}
						});
						return results;
					}
					const originalData = ((data || items) && this.state.group.length > 0) ? extractObjectsWithId(data || items) : [];
					const result = processWithGroups(this.state.group.length > 0 ? originalData : data || items, this.state.group);
					this.setState(prevState => ({
						...prevState,
						ungroupedData: originalData,
						data: hasGroups ? translateDataSourceResultGroups(data) : data || items,
						total: total || totalCount,
						updatedDataState,
						error: null,
						isLoading: false,
						result: this.state.group.length > 0 ? result : undefined,
					}));
				})
				.catch(err => {
					if (this.state?.gridStatus === 401) {
						this.props.history.push("/accessdenied");
					} else {
						this.setState(prevState => ({ ...prevState, error: apiCalls.isErrorDispaly(err), isLoading: false }))
					}
				})
		}
	}
}
